import React from 'react';
import { TicketAddModalSubmitButton } from './TicketAddModalSubmitButton';
import { ComboBoxParam, Fieldset, Row, Switch } from '../../../_lib/Form2';
import { ListBoxModifier, UserSingleSelectComboBoxForm2 } from '../../../components/molecules/Form/components/ComboBox';
import { Step } from '../../../components/molecules/Form/components/MultiStepForm';
import { FetchState } from '../../../hooks/reducers/useFetchReducer';
import { AxiosError, AxiosResponse } from 'axios';
import { SonResponseError } from '../../../_lib/Form2/types/SonResponseError';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type TicketModalMultiStepFormPersonStepProps = {
  supplierUserId: ComboBoxParam<'supplierUserId'>;
  firstToBeNotified: ComboBoxParam<'firstToBeNotifiedUserId'>;
  secondToBeNotified: ComboBoxParam<'secondToBeNotifiedUserId'>;
  fetchState: FetchState<AxiosResponse<any, any, object>, AxiosError<SonResponseError, any>>;
  showCheckListTable: boolean;
  setShowCheckListTable: (value: boolean) => void;
};

export function TicketModalMultiStepFormPersonStep({
  supplierUserId,
  firstToBeNotified,
  secondToBeNotified,
  fetchState,
  showCheckListTable,
  setShowCheckListTable,
}: TicketModalMultiStepFormPersonStepProps) {
  const { t } = useSonTranslation('TicketBooking');

  return (
    <Step
      id="ticket-add-modal-form-persons"
      buttonLabel={t('edit.form.steps.persons')}
      submitButton={!showCheckListTable ? <TicketAddModalSubmitButton fetchState={fetchState} /> : undefined}
    >
      <Fieldset legend={t('edit.form.legendSupplierDependent')}>
        <Row>
          <UserSingleSelectComboBoxForm2
            hiddenInputName={supplierUserId.name}
            labelTitle={t('edit.form.labelSupplierUserId')}
            helpText={t('edit.form.helpTextSupplierUserId')}
            suggestUrl={supplierUserId.comboBoxUrl.url}
            required={supplierUserId.required}
            modifierListBox={ListBoxModifier.MAX_HEIGHT_200}
          />
        </Row>
        <Row>
          <UserSingleSelectComboBoxForm2
            hiddenInputName={firstToBeNotified.name}
            labelTitle={t('edit.form.labelFirstPersonToBeNotified')}
            helpText={t('edit.form.helpTextPersonToBeNotified')}
            suggestUrl={firstToBeNotified.comboBoxUrl.url}
            required={firstToBeNotified.required}
            modifierListBox={ListBoxModifier.MAX_HEIGHT_200}
          />
        </Row>
        <Row>
          <UserSingleSelectComboBoxForm2
            hiddenInputName={secondToBeNotified.name}
            labelTitle={t('edit.form.labelSecondPersonToBeNotified')}
            helpText={t('edit.form.helpTextPersonToBeNotified')}
            suggestUrl={secondToBeNotified.comboBoxUrl.url}
            required={secondToBeNotified.required}
            modifierListBox={ListBoxModifier.MAX_HEIGHT_200}
          />
        </Row>
      </Fieldset>
      <Row>
        <Switch label={t('edit.form.labelShowCheckList')} onChange={() => setShowCheckListTable(!showCheckListTable)} />
      </Row>
    </Step>
  );
}
